import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import {
  Box,
  Button,
  Card,
  CardContent,
  IconButton,
  MobileStepper,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';

const CARD_WIDTH = 360;

const TourCard = ({
  index,
  step,
  backProps,
  closeProps,
  primaryProps,
  tooltipProps,
  ...props
}) => {
  const {t} = useTranslation();

  const nextButtonText = props.isLastStep
    ? step.finishLabel || t('tourDialog.buttonFinish')
    : t('tourDialog.buttonNext');

  const NextButton = () => (
    <Button size="small" data-qe="tour-card-next-button" {...primaryProps}>
      {nextButtonText}
      {!props.isLastStep && <KeyboardArrowRight />}
    </Button>
  );

  return (
    <Card
      raised
      sx={{width: CARD_WIDTH}}
      data-qe={`tour-card-${step.id}`}
      elevation={0}
      {...tooltipProps}
    >
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          px: 2,
          paddingTop: 1,
          marginBottom: 0.5,
          width: '100%',
        }}
      >
        <Typography
          variant="subtitle1"
          component="h2"
          data-qe="tour-card-title"
          sx={{
            display: 'block',
          }}
        >
          {step.title || ''}
        </Typography>
        <IconButton
          size="small"
          sx={{
            position: 'absolute',
            right: 2,
            top: 2,
            zIndex: 1,
          }}
          data-qe="tour-card-close-button"
          {...closeProps}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
      <CardContent sx={{marginTop: 1}}>
        <Typography variant="body2" data-qe="tour-card-content">
          {step.content}
        </Typography>
      </CardContent>
      {props.size > 1 ? (
        <MobileStepper
          position="static"
          steps={props.size}
          activeStep={index}
          nextButton={<NextButton />}
          elevation={0}
          sx={{
            background: 'inherit',
            boxShadow: 'none',
          }}
          backButton={
            <Button
              size="small"
              data-qe="tour-card-back-button"
              disabled={index === 0}
              {...backProps}
            >
              <KeyboardArrowLeft />
              {t('tourDialog.buttonBack')}
            </Button>
          }
          data-qe="tour-card-stepper"
        />
      ) : (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            paddingX: 1,
            paddingBottom: 1,
          }}
        >
          <NextButton />
        </Box>
      )}
    </Card>
  );
};

TourCard.propTypes = {
  continuous: PropTypes.bool,
  index: PropTypes.number,
  step: PropTypes.object,
  backProps: PropTypes.object,
  closeProps: PropTypes.object,
  primaryProps: PropTypes.object,
  tooltipProps: PropTypes.object,
  isLastStep: PropTypes.bool,
  size: PropTypes.number,
  finishLabel: PropTypes.string,
};

export default TourCard;
